import React from 'react'
import { MenuOption } from './styles'
import { Message } from '../Message'
import { Stack } from '~/styles'
import { QUESTIONS } from '~/constants/llm/question'

type QuestionMenuMessageProps = {
  onClick: (e: React.MouseEvent) => void
  disabled: boolean
}

export const QuestionMenuMessage = ({ onClick, disabled }: QuestionMenuMessageProps): JSX.Element => {
  return (
    <Message.RootLeft>
      <Message.UserAvatar iconName="MiMaleDoctor" />
      <Stack spacing="0.5rem" alignItems="flex-start">
        <Message.UserName username="IA Interativa" />
        <Message.FromLeft>
          <Stack alignItems="flex-start">
            <Message.PlainText text="Sugestões de perguntas:" />
            <Stack spacing="0.5rem" alignItems="flex-start">
              <MenuOption value={QUESTIONS[1].id} disabled={disabled} onClick={onClick}>
                {QUESTIONS[1].label}
              </MenuOption>

              <MenuOption value={QUESTIONS[2].id} disabled={disabled} onClick={onClick}>
                {QUESTIONS[2].label}
              </MenuOption>

              <MenuOption value={QUESTIONS[3].id} disabled={disabled} onClick={onClick}>
                {QUESTIONS[3].label}
              </MenuOption>

              <MenuOption value={QUESTIONS[4].id} disabled={disabled} onClick={onClick}>
                {QUESTIONS[4].label}
              </MenuOption>
            </Stack>
          </Stack>
        </Message.FromLeft>
      </Stack>
    </Message.RootLeft>
  )
}
